import type { ErrorResponse } from '@eika-infrastruktur/request';
import type { ErrorCodeConfigType } from '@translation-utils/translation-type';
import { useTranslation } from '@translations';

export const getPrettyErrorMessage = (error: ErrorResponse, fallback = ''): string => {
    const { errorCode, errors } = useTranslation();

    const prettyErrorCode = errorCode[error.code as keyof ErrorCodeConfigType];

    if (prettyErrorCode) {
        return prettyErrorCode;
    }

    if (fallback) {
        return fallback;
    }

    return errors.defaultMessage;
};
